import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { StaffTicket } from "@signalist/shared-types";

import { ROUTE_CONFIG } from "@/routes/config";

import { StaffTicketStatusPill } from "../../../components/StaffTicketPills";
import { RailHeading } from "./RailSection";

interface OtherCompanyTicketsProps {
	companyName: string | null;
	tickets: StaffTicket[];
}

/**
 * The company's other queue tickets (decision 7). A plain link: it carries no queue state, so the
 * detail it opens shows no Previous / Next.
 */
export const OtherCompanyTickets: FunctionComponent<OtherCompanyTicketsProps> = ({
	companyName,
	tickets,
}) => {
	const { t } = useTranslation();

	if (tickets.length === 0) {
		return null;
	}

	return (
		<>
			<RailHeading>
				{t("support.staff.detail.rail.otherTickets", { company: companyName ?? "" })}
			</RailHeading>
			<ul className="mt-1.5 flex flex-col gap-1.5">
				{tickets.map((ticket) => (
					<li key={ticket.id} className="flex min-w-0 items-center gap-2">
						<span className="w-12 shrink-0 tabular-nums text-text-meta">#{ticket.id}</span>
						<Link
							className="min-w-0 flex-1 truncate font-medium text-brand-light hover:underline"
							to={`${ROUTE_CONFIG.TICKETS}/${ticket.id}`}
						>
							{ticket.subject}
						</Link>
						<StaffTicketStatusPill status={ticket.status} />
					</li>
				))}
			</ul>
		</>
	);
};
